import { render, staticRenderFns } from "./PurchaseAndSale.vue?vue&type=template&id=714c461d&scoped=true&"
import script from "./PurchaseAndSale.vue?vue&type=script&lang=js&"
export * from "./PurchaseAndSale.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAndSale.vue?vue&type=style&index=0&id=714c461d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714c461d",
  null
  
)

export default component.exports